module.exports = __webpack_public_path__ + "img/lupa-bco.9bc1a7de.svg";